var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiplierIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 48a48 48 0 1 1-96 0 48 48 0 0 1 96 0ZM57.7 27.3a7.5 7.5 0 0 1 10.6 10.6l-9.9 10 10 9.8a7.5 7.5 0 1 1-10.7 10.6l-9.9-9.9-9.9 10a7.5 7.5 0 1 1-10.6-10.7l9.9-9.9-9.9-9.9a7.5 7.5 0 0 1 10.6-10.6l10 9.9 9.8-9.9Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplierIcon);
export default __webpack_public_path__ + "static/media/multiplier_icon.37052be999a4e6459aa6b2df0dbe0e97.svg";
export { ForwardRef as ReactComponent };